import { c as _createClass, b as _classCallCheck } from './createClass-3115abc1.esm.js';

var NftContractType;
(function (NftContractType) {
  NftContractType["Erc721"] = "ERC721";
  NftContractType["Erc1155"] = "ERC1155";
})(NftContractType || (NftContractType = {}));

var Profile = /*#__PURE__*/function () {
  function Profile(id, handle) {
    _classCallCheck(this, Profile);
    this.id = id;
    this.handle = handle;
  }
  _createClass(Profile, null, [{
    key: "create",
    value: function create(_ref) {
      var id = _ref.id,
        handle = _ref.handle;
      return new Profile(id, handle);
    }
  }]);
  return Profile;
}();

var ReactionType;
(function (ReactionType) {
  ReactionType["UPVOTE"] = "upvote";
  ReactionType["DOWNVOTE"] = "downvote";
})(ReactionType || (ReactionType = {}));
var DecryptionCriteriaType;
(function (DecryptionCriteriaType) {
  DecryptionCriteriaType["NFT_OWNERSHIP"] = "nft-ownership";
  DecryptionCriteriaType["ERC20_OWNERSHIP"] = "erc20-ownership";
  DecryptionCriteriaType["ADDRESS_OWNERSHIP"] = "address-ownership";
  DecryptionCriteriaType["PROFILE_OWNERSHIP"] = "profile-ownership";
  DecryptionCriteriaType["FOLLOW_PROFILE"] = "follow-profile";
  DecryptionCriteriaType["COLLECT_PUBLICATION"] = "collect-publication";
  DecryptionCriteriaType["COLLECT_THIS_PUBLICATION"] = "collect-this-publication";
  DecryptionCriteriaType["OR"] = "or";
  DecryptionCriteriaType["AND"] = "and";
})(DecryptionCriteriaType || (DecryptionCriteriaType = {}));
var Erc20ComparisonOperator;
(function (Erc20ComparisonOperator) {
  Erc20ComparisonOperator["Equal"] = "EQUAL";
  Erc20ComparisonOperator["NotEqual"] = "NOT_EQUAL";
  Erc20ComparisonOperator["GreaterThan"] = "GREATER_THAN";
  Erc20ComparisonOperator["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
  Erc20ComparisonOperator["LessThan"] = "LESS_THAN";
  Erc20ComparisonOperator["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
})(Erc20ComparisonOperator || (Erc20ComparisonOperator = {}));

// No entity was required so far for this use case.

var ReportReason;
(function (ReportReason) {
  ReportReason["ANIMAL_ABUSE"] = "ANIMAL_ABUSE";
  ReportReason["HARASSMENT"] = "HARASSMENT";
  ReportReason["VIOLENCE"] = "VIOLENCE";
  ReportReason["SELF_HARM"] = "SELF_HARM";
  ReportReason["DIRECT_THREAT"] = "DIRECT_THREAT";
  ReportReason["HATE_SPEECH"] = "HATE_SPEECH";
  ReportReason["NUDITY"] = "NUDITY";
  ReportReason["OFFENSIVE"] = "OFFENSIVE";
  ReportReason["SCAM"] = "SCAM";
  ReportReason["UNAUTHORIZED_SALE"] = "UNAUTHORIZED_SALE";
  ReportReason["IMPERSONATION"] = "IMPERSONATION";
  ReportReason["MISLEADING"] = "MISLEADING";
  ReportReason["MISUSE_HASHTAGS"] = "MISUSE_HASHTAGS";
  ReportReason["UNRELATED"] = "UNRELATED";
  ReportReason["REPETITIVE"] = "REPETITIVE";
  ReportReason["FAKE_ENGAGEMENT"] = "FAKE_ENGAGEMENT";
  ReportReason["MANIPULATION_ALGO"] = "MANIPULATION_ALGO";
  ReportReason["SOMETHING_ELSE"] = "SOMETHING_ELSE";
})(ReportReason || (ReportReason = {}));

export { DecryptionCriteriaType as D, Erc20ComparisonOperator as E, NftContractType as N, Profile as P, ReactionType as R, ReportReason as a };
